<template>
  <section id="qld-results">
    <article>
      <div class="header row clearfix">
        <img src="@/assets/img/2018/map-qld.png">

        <h1>Queensland</h1>
      </div>
      <div class="row clearfix">
        <div style="width: 80%;margin: 0 auto;">
          <figure>
            <h2>State Trends</h2>
            <highcharts class="graphcontainer" :options="trends"></highcharts>
          </figure>
        </div>
      </div>
      <div class="row clearfix">
        <figure class="sixcol chart">
          <h2>Category Share</h2>
          <div class="chart-wrapper">
            <highcharts class="graphcontainer pie" :options="activeCatShare"></highcharts>
            <div class="nb">NB: Numbers may not total 100.0% due to rounding.</div>
            <div class="nb">Categories/States with zero or &lt;0.05% of revenue and/or attendance<br> may not be reflected in the pie chart.</div>
          </div>
        </figure>
        <figure class="sixcol chart last">
          <h2>Regional/Metro Comparision</h2>
          <div class="chart-wrapper">
            <highcharts class="graphcontainer pie" :options="compRegionalMetro"></highcharts>
            <div class="nb">NB: Numbers may not total 100.0% due to a small proportion <br>of unidentified locations.</div>
          </div>
        </figure>
      </div>
      <h2 id="download-btn">Download the Report</h2>
      <div class="execsumm" style="justify-content: center;">
        <a href="./pdf/2025/QLD  Live Performance Industry in 2025.pdf" class="button fullreport pdf" target="_blank">
          QLD LPA Infographic Report 2025 (PDF)
        </a>
      </div>
    </article>
    <div class="fullbg">
      <p class="caption">Photo: <em>Romeo and Juliet</em>, Queensland Ballet, Photo Credit: David Kelly</p>
      <div class="overlay"></div>
    </div>
  </section>
</template>

<script>
/*eslint-disable */
export default {
  data () {
    return {
      activeYear: 2025,
      trends: {
        chart: {
          type: 'column',
          backgroundColor: 'transparent'
        },
        title: {
          style: { color: '#fff' },
          text: 'Total Revenue and Attendance'
        },
        legend: {
          itemStyle: { color: '#fff', fontWeight: 'normal' },
          itemHoverStyle: { color: '#fff' }
        },
        xAxis: {
          categories: [2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025],
          labels: {
            style: {
              color: '#fff'
            },
            rotation: -45,
            staggerLines: 1,
          }
        },
        yAxis: [{ // Primary yAxis
          min: 0,
          labels: {
            formatter () {
              if (this.value > 999) {
                // return this.key +'<br />'+this.y+'% '
                return '$' + (this.value / 1000) + 'b'
              } else {
                return '$' + this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Gross Revenue',
            style: {
              color: '#fff'
            }
          },
          opposite: true
        }, { // Secondary yAxis
          min: 0,
          labels: {
            formatter() {
              return this.value.toFixed(0) + 'm'
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Total Attendance',
            style: {
              color: '#fff'
            }
          },
          opposite: false
        }],
        tooltip: {
          shared: true,
          formatter () {
            let revy, tooltipstring, avg;
            let rev = this.points[0];
            let att = this.points[1];
            let atty = att.y.toFixed(2) + 'm';
            let chart = this.points[0].series.chart;
            let categories = chart.xAxis[0].categories;
            let index = 0;
            while (this.x !== categories[index]) {
              index++;
            }
            for (let i=0; i<chart.series.length; i++) {
              let series = chart.series[i];
              avg = series.data[index].y;
            }
            if (rev.y > 1000) {
              revy = '$' + (rev.y / 1000).toFixed(3) + 'b'
            }
            else {
              revy = '$' + rev.y.toFixed(3) + 'm'
            }
            tooltipstring = this.x + '<br />';
            tooltipstring += '<span style="color:' + att.series.color + '">•</span> Attendance: ' + atty + '<br />'
            tooltipstring += '<span style="color:' + rev.series.color + '">•</span> Revenue: ' + revy
            return tooltipstring
          }
        },
        series: [
          {
            name: 'Revenue',
            data: [146.568, 160.521, 165.841, 183.775, 200.179, 203.918, 195.337, 180.305, 263.878, 317.18, 286.192, 116.869, 132.908, 303.029, 539.301, 514.022, 506.376],
            color: '#3a89eb',
          },
          {
            name: 'Attendance',
            data: [2.007, 2.043, 2.15, 2.302, 2.318, 2.662, 2.915, 2.528, 3.197, 3.84, 3.477, 1.260, 2.214, 3.728, 4.938, 4.944, 4.674],
            color: '#d14967',
            type: 'column',
            yAxis: 1,
          }
        ]
      },
      compRegionalMetro: {
        chart: {
          type: 'pie',
          backgroundColor: 'transparent'
        },
        legend: {
          itemStyle: { color: '#fff', fontWeight: 'normal' },
          itemHoverStyle: { color: '#fff' }
        },
        title: {
          text: ''
        },
        subtitle: {
          text: ''
        },
        plotOptions: {
          series: {
            states: {
              inactive: {
                opacity: 1
              }
            }
          },
          pie: {
            shadow: false,
            center: ['50%', '50%'],
            dataLabels: {
              enabled: true,
              style: {
                fontWeight: 'bold',
                color: 'white',
                textShadow: '0px 1px 2px black'
              }
            },
            point: {
              events: {
                legendItemClick (e) {
                  e.preventDefault()
                  return false
                }
              }
            }
          }
        },
        tooltip: {
          valueSuffix: '%',
          valueDecimals: 1
        },
        series: [{
          name: 'Attendance Share',
          data: [
            ['Metro', 75.8],
            ['Regional', 23.7],
            ['Unknown', 0.5],
          ],
          size: '68%',
          innerSize: '40%',
          borderColor: 'none',
          borderWidth: 1,
          slicedOffset: 30,
          showInLegend: false,
          dataLabels: {
            color: '#000',
            style: {
              textShadow: 'none'
            },
            formatter () {
              if (this.y > 3) {
                return this.y.toFixed(1) + '%'
              }
            },
            distance: -28
          },
          colors: ['#ACDFF4','#F7977A','#82CA9D']
        }, {
          name: 'Revenue Share',
          data: [
            ['Metro', 80.5],
            ['Regional', 19.5],
            ['Unknown', 0],
          ],
          size: '100%',
          innerSize: '70%',
          borderColor: 'none',
          borderWidth: 1,
          showInLegend: false,
          dataLabels: {
            color: '#000',
            style: {
              textShadow: 'none'
            },
            formatter () {
              if (this.y > 3) {
                return this.y.toFixed(1) + '%'
              }
            },
            distance: -28
          },
          colors: ['#ACDFF4','#F7977A','#82CA9D']
        }],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 400
            },
            chartOptions: {
              series: [{
              }, {
                id: 'versions',
                dataLabels: {
                  enabled: false
                }
              }]
            }
          }]
        }
      },
      catShares: [
        {
          year: 2025,
          revenue: [
            ['Ballet and Dance', 2.7],
            ['Children\'s/Family', 2.1],
            ['Classical Music', 3.5],
            ['Comedy', 4.1],
            ['Circus and Physical Theatre', 3.4],
            ['Festivals (Multi-Category)', 2.7],
            ['Musical Theatre', 11.3],
            ['Contemporary Music', 54.1],
            ['Opera', 0.0],
            ['Festivals (Contemporary Music)', 12.8],
            ['Special Events', 0.5],
            ['Theatre', 2.8],
          ],
          attendance: [
            ['Ballet and Dance', 3.1],
            ['Children\'s/Family', 5.6],
            ['Classical Music', 4.1],
            ['Comedy', 7.2],
            ['Circus and Physical Theatre', 4.4],
            ['Festivals (Multi-Category)', 3.9],
            ['Musical Theatre', 10.0],
            ['Contemporary Music', 47.8],
            ['Opera', 0.2],
            ['Festivals (Contemporary Music)', 7.4],
            ['Special Events', 2.6],
            ['Theatre', 3.9],
          ]
        }
      ]
    }
  },
  computed: {
    activeCatShare () {
      const self = this

      for (let i = 0; i < self.catShares.length; i++) {
        const catShare = self.catShares[i]
        if (catShare.year === self.activeYear) {
          return {
            chart: {
              type: 'pie',
              backgroundColor: 'transparent'
            },
            title: {
              text: ''
            },
            subtitle: {
              text: ''
            },
            plotOptions: {
              series: {
                states: {
                  inactive: {
                    opacity: 1
                  }
                }
              },
              pie: {
                shadow: false,
                center: ['50%', '50%'],
                dataLabels: {
                  enabled: true,
                  style: {
                    fontWeight: 'bold',
                    color: 'white',
                    textShadow: '0px 1px 2px black'
                  }
                },
                point: {
                  events: {
                    legendItemClick (e) {
                      e.preventDefault()
                      return false
                    }
                  }
                }
              }
            },
            tooltip: {
              valueSuffix: '%',
              valueDecimals: 1
            },
            series: [{
              name: 'Attendance Share',
              data: catShare.attendance,
              size: '68%',
              innerSize: '40%',
              borderColor: 'none',
              borderWidth: 1,
              slicedOffset: 30,
              showInLegend: false,
              dataLabels: {
                color: '#000',
                style: {
                  textShadow: 'none'
                },
                formatter () {
                  if (this.y > 3) {
                    return this.y.toFixed(1) + '%'
                  }
                },
                distance: -28
              },
              colors: ['#BC8DBF', '#70CB92', '#6ECFF6', '#7EA7D8', '#82CA9D', '#8882BE', '#ACDFF4', '#F7977A']
            },
              {
                name: 'Revenue Share',
                data: catShare.revenue,
                size: '100%',
                innerSize: '70%',
                borderColor: 'transparent',
                borderWidth: 1,
                dataLabels: {
                  color: '#000',
                  style: {
                    textShadow: 'none'
                  },
                  formatter () {
                    if (this.y > 3) {
                      return this.y.toFixed(1) + '%'
                    }
                  },
                  distance: -28
                },
                colors: ['#BC8DBF', '#70CB92', '#6ECFF6', '#7EA7D8', '#82CA9D', '#8882BE', '#ACDFF4', '#F7977A']
              }],
            responsive: {
              rules: [{
                condition: {
                  maxWidth: 400
                },
                chartOptions: {
                  series: [{
                  }, {
                    id: 'versions',
                    dataLabels: {
                      enabled: false
                    }
                  }]
                }
              }]
            }
          }
        }
      }

      return false
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped="scoped">
.chart-wrapper {
  position: relative;
  .nb {
    // position: absolute;
    // bottom: 0;
    // right: 0;
    color: #fff;
    font-style: italic;
    font-size: 12px;
  }
}
</style>
